/**
 * Hunts page tab IA (field-edition 4a): My Hunts vs Hunt Forecast.
 */

export const HUNTS_TAB_LOG = 'log';
export const HUNTS_TAB_FORECAST = 'forecast';

export const HUNTS_SHELL_TABS = [
  { id: HUNTS_TAB_LOG, label: 'My Hunts' },
  { id: HUNTS_TAB_FORECAST, label: 'Hunt Forecast' },
];

export function parseHuntsTab(searchParams) {
  const raw =
    typeof searchParams?.get === 'function'
      ? searchParams.get('tab')
      : new URLSearchParams(searchParams || '').get('tab');
  return String(raw || '').toLowerCase() === HUNTS_TAB_FORECAST
    ? HUNTS_TAB_FORECAST
    : HUNTS_TAB_LOG;
}

export function huntsTabSearch(tabId) {
  if (tabId === HUNTS_TAB_FORECAST) return { tab: HUNTS_TAB_FORECAST };
  return {};
}
